import React from 'react'
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

import meme1 from "../../../assets/images/meme.jpg"
import meme2 from "../../../assets/images/meme2.jpeg"
import meme3 from "../../../assets/images/meme3.jpg"
import meme4 from "../../../assets/images/meme4.jpg"
import meme5 from "../../../assets/images/meme5.jpg"
import meme6 from "../../../assets/images/meme6.jpeg"
import meme7 from "../../../assets/images/meme7.jpg"
import meme8 from "../../../assets/images/meme8.jpg"
import meme9 from "../../../assets/images/meme9.jpg"
import meme10 from "../../../assets/images/meme10.jpg"
import meme11 from "../../../assets/images/meme11.jpg"
import meme12 from "../../../assets/images/meme12.jpg"
import meme13 from "../../../assets/images/meme13.jpg"
import meme14 from "../../../assets/images/meme14.jpg"
import meme15 from "../../../assets/images/meme15.jpg"

// import required modules
import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
// import { , Pagination, Navigation } from 'swiper/modules';

import styled from '@emotion/styled';
import { Grid, keyframes } from '@mui/material';

// import { Pagination } from "swiper";
const Iasdmg = styled.img`  
width: 100%;
height:auto;
max-width: ${(props) => (props.maxWidth ? props.maxWidth : "300px")};
padding: 0 50px;
`
const Div = styled.div`
 /* background: ${(props) => (props.bgcolor ? props.bgcolor : "linear-gradient(235deg, #00EAFF 20%,#0080FF 30%,#0080FF 27%,#8000FF 43%, #E619E6 60%,#FF0000 92%)")}; */
  
  padding: ${(props) => (props.padding ? props.padding : "8px 0")};
`
const GridInside = styled(Grid)`
display: flex;
    place-content: center;
`
const Swipe = (props) => {
    const handleDownload = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = 'image.jpg';
        link.click();
    };
    return (
        // "linear-gradient(235deg, #00EAFF 20%,#0080FF 30%,#0080FF 27%,#8000FF 43%, #E619E6 60%,#FF0000 92%)"
        <Div >
            <marquee scrollamount="20" behavior="scroll" direction="left" loop="infinite">
                {/* <Iasdmg onClick={() => handleDownload(meme1)} alt="Logo" src={meme1} />
                <Iasdmg onClick={() => handleDownload(meme2)} alt="Logo" src={meme2} />
                <Iasdmg onClick={() => handleDownload(meme3)} alt="Logo" src={meme3} />
                <Iasdmg onClick={() => handleDownload(meme4)} alt="Logo" src={meme4} />
                <Iasdmg onClick={() => handleDownload(meme5)} alt="Logo" src={meme5} />
                <Iasdmg onClick={() => handleDownload(meme6)} alt="Logo" src={meme6} />
                <Iasdmg onClick={() => handleDownload(meme7)} alt="Logo" src={meme7} />
                <Iasdmg onClick={() => handleDownload(meme8)} alt="Logo" src={meme8} />
                <Iasdmg onClick={() => handleDownload(meme9)} alt="Logo" src={meme9} />
                <Iasdmg onClick={() => handleDownload(meme10)} alt="Logo" src={meme10} />
                <Iasdmg onClick={() => handleDownload(meme11)} alt="Logo" src={meme11} />
                <Iasdmg onClick={() => handleDownload(meme12)} alt="Logo" src={meme12} />
                <Iasdmg onClick={() => handleDownload(meme13)} alt="Logo" src={meme13} />
                <Iasdmg onClick={() => handleDownload(meme14)} alt="Logo" src={meme14} />
                <Iasdmg onClick={() => handleDownload(meme15)} alt="Logo" src={meme15} /> */}
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
                <Iasdmg alt="Logo" src={meme1} />
                <Iasdmg alt="Logo" src={meme2} />
                <Iasdmg alt="Logo" src={meme3} />
                <Iasdmg alt="Logo" src={meme4} />
                <Iasdmg alt="Logo" src={meme5} />
                <Iasdmg alt="Logo" src={meme6} />
                <Iasdmg alt="Logo" src={meme7} />
                <Iasdmg alt="Logo" src={meme8} />
                <Iasdmg alt="Logo" src={meme9} />
                <Iasdmg alt="Logo" src={meme10} />
                <Iasdmg alt="Logo" src={meme11} />
                <Iasdmg alt="Logo" src={meme12} />
                <Iasdmg alt="Logo" src={meme13} />
                <Iasdmg alt="Logo" src={meme14} />
                <Iasdmg alt="Logo" src={meme15} />
            </marquee>
            {/* <Swiper slidesPerView={3}
                spaceBetween={30}
                freeMode={true}
               
                modules={[Autoplay,FreeMode]}
                autoplay={{
                    delay: 800,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 4,
                      spaceBetween: 40,
                    },
                    1024: {
                      slidesPerView: 5,
                      spaceBetween: 50,
                    },
                  }}
                className="mySwiper"
            >

                <SwiperSlide><Iasdmg alt="Logo" src={meme1} /></SwiperSlide>
                <SwiperSlide>
                    <Iasdmg alt="Logo" src={meme2} /></SwiperSlide>
                <SwiperSlide>
                    <Iasdmg alt="Logo" src={meme3} /></SwiperSlide>
                <SwiperSlide>
                    <Iasdmg alt="Logo" src={meme4} /></SwiperSlide>
                <SwiperSlide>
                    <Iasdmg alt="Logo" src={meme5} /></SwiperSlide>
                <SwiperSlide>

                    <Iasdmg alt="Logo" src={meme6} /></SwiperSlide>
                <SwiperSlide>
                    <Iasdmg alt="Logo" src={meme1} /></SwiperSlide>
                <SwiperSlide>
                    <Iasdmg alt="Logo" src={meme2} /></SwiperSlide>
                <SwiperSlide>
                    <Iasdmg alt="Logo" src={meme3} /></SwiperSlide>







            </Swiper> */}
        </Div>
    )
}

export default Swipe